import { computed, nextTick, ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { cloneNested, parseRequestError } from '@/helpers/helpers'

export default (props, { root }) => {
  const router = root.$router
  const store = root.$store
  const me = computed(() => store.getters['auth/getUser'])
  const currentTabIndex = ref(1)
  const steps = ref([
    {
      name: i18n.t('wizard.step-1.title'),
      component: 'wizard-step-1',
      enabled: true,
    },
    {
      name: i18n.t('wizard.step-2.title'),
      component: 'wizard-step-2',
      enabled: false,
    },
    {
      name: i18n.t('wizard.step-3.title'),
      component: 'wizard-step-3',
      enabled: false,
    },
  ])

  const isDisabled = index => index > currentTabIndex.value
  const getAvatarBackground = index => {
    if (index === currentTabIndex.value) {
      return 'primary'
    }
    if (index > currentTabIndex.value) {
      return 'light-secondary'
    }
    return 'light-primary'
  }

  const handleNext = () => {
    steps.value[currentTabIndex.value + 1].enabled = true
    nextTick(() => {
      currentTabIndex.value += 1
    })
  }

  const handleSubmit = () => {
    const newMe = cloneNested(me.value)
    newMe.organization.profileComplete = true
    store.commit('auth/SET_USER_INFO', newMe)
    router.push({ name: 'dashboard-redirect' })

    store.dispatch(
      'organization/patchOrganization',
      {
        id: me.value.organization.id,
        data: { profileComplete: true },
      },
    )
      .catch(err => {
        parseRequestError(err)
      })
  }

  return {
    currentTabIndex,
    steps,

    isDisabled,
    getAvatarBackground,
    handleNext,
    handleSubmit,
  }
}
